import React from 'react';
import {
  Box,
  Button,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import SeasonPicker from '../SeasonPicker';
import { PurchaseOrderStatsBucket } from '../../../types/purchasing';
import SupplierPicker from '../SupplierPicker';
import { SupplierOption } from '../../../types/purchasing';

export default function PurchaseOrderStatsFiltersBar(props: {
  bucket: PurchaseOrderStatsBucket;
  onBucketChange: (bucket: PurchaseOrderStatsBucket) => void;
  season: string | null;
  onSeasonChange: (season: string | null) => void;
  suppliers: SupplierOption[];
  suppliersLoading?: boolean;
  supplierId: number | null;
  onSupplierIdChange: (supplierId: number | null) => void;
  deliveryMonthFrom: string | null;
  onDeliveryMonthFromChange: (month: string | null) => void;
  deliveryMonthTo: string | null;
  onDeliveryMonthToChange: (month: string | null) => void;
  onReset: () => void;
}) {
  const {
    bucket,
    onBucketChange,
    season,
    onSeasonChange,
    suppliers,
    suppliersLoading = false,
    supplierId,
    onSupplierIdChange,
    deliveryMonthFrom,
    onDeliveryMonthFromChange,
    deliveryMonthTo,
    onDeliveryMonthToChange,
    onReset,
  } = props;

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 2,
        bgcolor: 'background.default',
        py: 1,
        mb: 2,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={1.5}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        justifyContent="space-between"
      >
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={1.5}
          alignItems={{ xs: 'stretch', md: 'center' }}
          sx={{ flexWrap: 'wrap' }}
          useFlexGap
        >
          <Box sx={{ minWidth: { xs: 'auto', md: 220 } }}>
            <SeasonPicker
              value={season}
              onChange={(code) => onSeasonChange(code || null)}
            />
          </Box>

          <Box sx={{ minWidth: { xs: 'auto', md: 260 } }}>
            <SupplierPicker
              suppliers={suppliers}
              value={supplierId}
              onChange={onSupplierIdChange}
              disabled={suppliersLoading}
            />
          </Box>

          <TextField
            label="Leveransmånad från"
            type="month"
            size="small"
            value={deliveryMonthFrom || ''}
            onChange={(e) => onDeliveryMonthFromChange(e.target.value || null)}
            sx={{ minWidth: { xs: 'auto', md: 190 } }}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Leveransmånad till"
            type="month"
            size="small"
            value={deliveryMonthTo || ''}
            onChange={(e) => onDeliveryMonthToChange(e.target.value || null)}
            sx={{ minWidth: { xs: 'auto', md: 190 } }}
            InputLabelProps={{ shrink: true }}
          />

          <Button size="small" variant="text" onClick={onReset}>
            Rensa filter
          </Button>
        </Stack>

        <ToggleButtonGroup
          exclusive
          value={bucket}
          onChange={(_, next) => next && onBucketChange(next)}
          size="small"
        >
          <ToggleButton value="draft">Utkast</ToggleButton>
          <ToggleButton value="done">Färdigmarkerade</ToggleButton>
          <ToggleButton value="all">Alla</ToggleButton>
        </ToggleButtonGroup>
      </Stack>
    </Box>
  );
}
